import Carousel from "react-material-ui-carousel";
import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types"; // Correct import for PropTypes
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { fetchShowingOffer } from "../signals/offerData.signal";
import { isOffer } from "../signals/homeData.signal";
import { Link } from "react-router-dom";
import { signalPagePath } from "../signals/login.signal";
import LazyImage from "./LazyImage";

const Slideshow = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchShowingOffer();
        // const filteredItems = items.filter(item => item.OFFER_TYPE === 'IMG');
        const filteredItems = result.filter(
          (item) => item.OFFER_TYPE === "IMG" || item.OFFER_TYPE === "VIDEO"
        );
        setItems(filteredItems);
        isOffer.value = filteredItems;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  return isOffer.value ? (
    isOffer.value.length > 0 && (
      <div className="p-3 w-100 col-12 position-sticky">
        <div
          className="shadow rounded-3 overflow-hidden w-100 col-12 "
          style={{ height: "300px" }}
        >
          <Link
            to={signalPagePath.value ? "/offer" : "/"}
            onClick={() => window.scrollTo(0, 0)}
            className="text-black"
          >
            <Carousel
              height={"100%"}
              className="h-100"
              indicators={false}
              navButtonsAlwaysVisible={false}
            >
              {items.map((item, i) => (
                <SlideItem key={i} item={item} />
              ))}
            </Carousel>
          </Link>
        </div>
      </div>
    )
  ) : (
    <></>
  );
};

const SlideItem = ({ item }) => {
  const videoRef = useRef(null);
  const [isPlaying, setPlaying] = useState(false);

  const handleVideoClick = () => {
    const video = videoRef.current;

    if (!video) return;

    if (video.paused) {
      video.play();
      setPlaying(true);
    } else {
      video.pause();
      video.currentTime = 0;
      setPlaying(false);
    }
  };

  const handleMouseLeave = () => {
    const video = videoRef.current;

    if (!video || !isPlaying) return;

    video.pause();
    video.currentTime = 0;
    setPlaying(false);
  };

  return (
    <div className="h-100 h-100 position-relative">
      <div className="overflow-hidden h-100 bg-white p-0 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center position-relative">
        <div className="h-100 border w-100 rounded-3 bg-secondary-subtle position-relative">
          <div className="w-100 h-100 d-flex">
            <div className="w-100 h-100">
              {item.OFFER_TYPE === "IMG" ? (
                <LazyImage
                  src={item.OFFER_IMG}
                  alt="Offer"
                  height="100%"
                  width="100%"
                  style={{
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                  className="rounded-3"
                />
              ) : item.OFFER_TYPE === "VIDEO" ? (
                <>
                  <div
                    className="align-items-center d-flex h-100 justify-content-center position-absolute w-100"
                    onClick={handleVideoClick}
                  >
                    {!isPlaying && (
                      <PlayCircleOutlineIcon
                        sx={{
                          cursor: "pointer",
                          fontSize: 40,
                          background: "#FFF",
                          borderRadius: "100px",
                        }}
                      />
                    )}
                  </div>
                  <video
                    ref={videoRef}
                    className="w-100"
                    loop
                    playsInline
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                    onClick={handleVideoClick}
                    onMouseLeave={handleMouseLeave}
                  >
                    <source src={item.OFFER_IMG} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </>
              ) : item.OFFER_TYPE === "TEXT" ? (
                // <div
                //   style={{
                //     width: "100%",
                //     height: "100%",
                //     display: "flex",
                //     justifyContent: "center",
                //     flexDirection: "column",
                //     alignItems: "center",
                //     textAlign: "center",
                //     padding: "20px",
                //     boxSizing: "border-box",
                //   }}
                // >
                //   <p className="h-25 m-0">{item.OFFER_TEXT}</p>
                //   <hr className="w-100 m-1" />
                //   <p className="m-0 h-100">{item.OFFER_TEXT}</p>
                // </div>
                <></>
              ) : (
                <div>Unknown Offer Type</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SlideItem.propTypes = {
  item: PropTypes.shape({
    OFFER_TYPE: PropTypes.string,
    OFFER_IMG: PropTypes.string,
    OFFER_TEXT: PropTypes.string,
  }).isRequired,
};

export default Slideshow;
